// extracted by mini-css-extract-plugin
export var container = "_5l-0";
export var fallback = "_5l-5";
export var fallbackIcon = "_5l-6";
export var hidden = "_5l-2";
export var image = "_5l-3";
export var loaded = "_5l-4";
export var placeholder = "_5l-1";